import {
	ResponsiveContainer,
	ComposedChart,
	XAxis,
	YAxis,
	Bar,
	Line,
	Tooltip,
	LabelList,
	BarChart,
	Legend,
} from "recharts";
import { numberFormatter } from "../../utils";
interface Props {
	chartData: Array<T>;
}
interface T {
	quarter: string;
	forecastBase: number;
	additionalBase: number;
	forecastGrowth: number;
	additionalGrowth: number;
	// cumulativeTarget: number
}
const RebateChartNIASimulator = (props: Props) => {
	const data = props.chartData;
	const footerData = [
		{ category: "actualSales" },
		{ category: "forecasetdSales" },
		{ category: "additionalPurchases" },
		{ category: "salesMovementFromPeers" },
		{ category: "targetGrowthSales" },
		{ category: "lastYear" },
	];
	const updateFill = (category: any) => {
		switch (category) {
			case "actualSales":
				return "#3B60A0";
			case "forecasetdSales":
				return "#86BC25";
			case "additionalPurchases":
				return "#012169";
			case "salesMovementFromPeers":
				return "#0097A9";
			case "targetGrowthSales":
				return "#5EC1C8";
			case "lastYear":
				return "#DA505582";
			default:
				return "#000";
		}
	};

	const updateLegend = (category: any) => {
		switch (category) {
			case "actualSales":
				return `Actual `;
			case "forecasetdSales":
				return `Forecasted ($)`;
			case "additionalPurchases":
				return `Additional Purchases ($)`;
			case "salesMovementFromPeers":
				return ` Movement From Peers($)`;
			case "targetGrowthSales":
				return `Target Growth ($)`;
			case "lastYear":
				return `Last Year ($)`;
			default:
				return category;
		}
	};

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">Quarter:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.quarter}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						{(data.forecastBase > 0 || data.forecastGrowth > 0) && (
							<>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Forecasted Base($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(data.forecastBase, 0)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Forecasted Growth($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.forecastGrowth,
											0
										)}
									</label>
								</p>
							</>
						)}
						{(data.additionalBase > 0 ||
							data.additionalGrowth > 0) && (
							<>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Additional Base($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.additionalBase,
											0
										)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Additional Growth($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.additionalGrowth,
											0
										)}
									</label>
								</p>
							</>
						)}
					</div>
				</div>
			);
		}
		return null;
	};

	const renderCustomLegend = (props: any) => {
		const { payload } = props;
		return (
			<ul
				style={{
					listStyleType: "none",
					padding: 0,
					display: "flex",
					flexWrap: "wrap",
					columnGap: "2vh",
					marginLeft: "4vh",
				}}
			>
				{payload.map((entry: any, index: any) =>
					entry.value == "totalGrowthRebate" ? (
						<></>
					) : (
						<li
							key={`item-${index}`}
							style={{
								display: "flex",
								alignItems: "center",
								marginBottom: 4,
								color: entry.color,
								fontSize: "1.8vh",
							}}
						>
							{entry.value != "Total Rebate $" && (
								<div
									style={{
										width: 10,
										height: 10,
										backgroundColor: entry.color,
										marginRight: 8,
									}}
								></div>
							)}
							{entry.value}
						</li>
					)
				)}
			</ul>
		);
	};
	return (
		<div className="w-full">
			<div className="headSpace">
				<div className="headContent">Estimated Rebate Trend ($) ​ </div>
			</div>
			<ResponsiveContainer width="90%" height="70%">
				<BarChart
					data={data}
					margin={{
						top: 20,
						right: 30,
						left: 30,
					}}
				>
					<XAxis
						dataKey="quarter"
						className="graph-label"
						stroke="black"
					/>
					<YAxis
						className="graph-label"
						tickFormatter={(value: number) =>
							numberFormatter(value, 0, "$")
						}
						stroke="black"
					/>
					<Tooltip
						contentStyle={{
							color: "black",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
						content={customTooltip}
					/>

					<Bar
						dataKey="actualBase"
						name="Actual Base($)"
						stackId="a"
						fill="#3B60A0"
						barSize={40}
						className="graph-label-small"
					>
						<LabelList
							dataKey="actualBase"
							fill="white"
							className="graph-label-small"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						dataKey="forecasetdBase"
						name="Forecasted Base($)"
						stackId="a"
						fill="#86BC25"
						barSize={40}
						className="graph-label-small"
					>
						<LabelList
							dataKey="forecasetdBase"
							fill="white"
							className="graph-label-small"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						className="graph-label-small"
						dataKey="additionalBase"
						name="Additional Base($)"
						stackId="a"
						fill="#012169"
						barSize={40}
					></Bar>
					<Bar
						dataKey="forecastedGrowth"
						name="Forecasted Growth($)"
						stackId="b"
						fill="#0097A9"
						barSize={40}
						className="graph-label-small"
					>
						<LabelList
							dataKey="forecastedGrowth"
							fill="white"
							className="graph-label-small"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						dataKey="additionalGrowth"
						name="Additional Growth($)"
						stackId="b"
						fill="#5EC1C8"
						barSize={40}
					>
						<LabelList
							dataKey="additionalGrowth"
							fill="white"
							className="graph-label-small"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						dataKey="totalGrowthRebate"
						name={`totalGrowthRebate`}
						stackId="b"
						fill="#EAA61482"
						barSize={40}
					>
						<LabelList
							dataKey="totalGrowthRebateLabel"
							fill="#EAA614"
							className="graph-label-small"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 1, "$")
							}
							position="top"
						></LabelList>
					</Bar>
					<Bar
						dataKey="totalRebate"
						name={`Total Rebate $`}
						stackId="a"
						fill="#EAA61482"
						barSize={40}
					>
						<LabelList
							dataKey="totalRebateLabel"
							fill="#EAA614"
							className="graph-label-small"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 1, "$")
							}
							position="top"
						></LabelList>
					</Bar>
				</BarChart>
			</ResponsiveContainer>
			<div className="contentFooter pt-[2vh]">
				<div className="flex flex-wrap items-start gap-x-2 px-4 w-full">
					{footerData.map((entry, index) => (
						<div
							key={`legend-${index}`}
							className="flex items-center min-h-[20px] cursor-pointer"
						>
							<div
								className="w-3 h-3 mr-2"
								style={{
									backgroundColor: updateFill(entry.category),
								}}
							></div>
							<span
								className="text-[0.85em] leading-tight"
								style={{
									color: updateFill(entry.category),
								}}
							>
								{updateLegend(entry.category)}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
export default RebateChartNIASimulator;
